const toSentence = (items: string[], maximum: number | null = null) => {
  const { length } = items;

  if (length === 0) {
    return "";
  }
  if (length === 1) {
    return items[0];
  }
  if (length === 2) {
    return `${items[0]} and ${items[1]}`;
  }
  if (maximum && length >= maximum) {
    return `${items.slice(0, maximum - 2).join(", ")}, and ${length - maximum + 2} others`;
  }
  return `${items.slice(0, length - 1).join(", ")}, and ${items[length - 1]}`;
};

export default toSentence;
